import styled from 'styled-components';
import { useService } from '@visiba/instantiation';
import { usePresentation } from '@visiba/presentation';
import { AnalyticAction } from '@application/analytic/analytic.service';
import { LinkReceptionPicker } from './_header_nav_link_reception_picker.component';
import { LinkMyCases } from './_header_nav_link_my_cases.component';
import { LinkHome } from './_header_nav_link_home.component';
import { HeaderNavController } from '@controllers/header_nav.controller';
import { tokens } from '@cellula/react-theme-patient';

interface Props {
	trackEvent: (action: AnalyticAction) => void;
	__TEMP__navigate?: (url: string) => void;
}

const elements = {
	wrapper: styled.div`
		display: none;

		${tokens.breakpointQuery.medium} {
			display: grid;
			grid-template-columns: repeat(3, 1fr);
			width: 100%;
			height: 100%;
		}
	`,
};

export function Nav({ __TEMP__navigate, trackEvent }: Props): JSX.Element {
	const headerNavController = useService(HeaderNavController);
	const { showLinkHome, showLinkReceptionPicker, showLinkMyCases } = usePresentation(headerNavController.presentation);

	function handleClick(action: AnalyticAction): void {
		trackEvent(action);
	}

	return (
		<elements.wrapper>
			{showLinkHome ? <LinkHome trackEvent={handleClick} __TEMP__navigate={__TEMP__navigate} /> : null}
			{showLinkReceptionPicker ? <LinkReceptionPicker trackEvent={handleClick} __TEMP__navigate={__TEMP__navigate} /> : null}
			{showLinkMyCases ? <LinkMyCases trackEvent={handleClick} __TEMP__navigate={__TEMP__navigate} /> : null}
		</elements.wrapper>
	);
}
